export const notifications = (state) => state.notifications
export const tags = (state) => state.notifications.tags
export const notificationsAll = (state) => state.notifications.notifications
export const isLoading = (state) => state.notifications.isLoading
export const isSuccess = (state) => state.notifications.isSuccess
